import React from 'react'
import event_1 from'../Assets/Images/event1.jpg'
import event2 from'../Assets/Images/event2.jpg'
import event3 from'../Assets/Images/event3.jpg'
import Slider from "react-slick";
const Events = () => {
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll:2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  };
  return (
   <>
   <Slider {...settings}>
   <div>
               <div className="event-blk">
                   <div className="event-image"> 
                       <img src={event3} alt="Sacred Heart Convent School, Jagraon"/>
                   </div>
                   <div className="content">
                       <h3>Basant Panchami</h3>
                       <p>Stay connected for more updates!</p>
                       <p><span>14.02.24  | HH:MM</span></p>
                   </div>
               </div>
               </div>
               <div>
               <div className="event-blk">
                   <div className="event-image"> 
                       <img src={event_1} alt="Sacred Heart Convent School, Jagraon"/>
                   </div>
                   <div className="content">
                       <h3>Holi Celebration</h3>
                       <p>Stay connected for more updates!</p>
                       <p><span>25.03.24  | HH:MM</span></p>
                   </div>
               </div>
               </div>
               <div>
               <div className="event-blk">
                   <div className="event-image"> 
                       <img src={event2} alt="Sacred Heart Convent School, Jagraon"/>
                   </div>
                   <div className="content">
                       <h3>Good Friday</h3>
                       <p>Stay connected for more updates!</p>
                       <p><span>29.03.24  | HH:MM</span></p>
                   </div>
               </div>
               </div>
      </Slider>
   </>
  )
}

export default Events